

































































































import { Component, Mixins, Watch, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CustomForm from '@/components/custom-form/index.vue'
import OrderRefundApi from '@/api/order/refund/newIndex'

@Component({
  components: {
    CustomForm,
  },
})
export default class NewRefundList extends AbpBase {
  updateGuanYiTradeNoModal = false
  formItem = {
    id: '',
    externalCode: '',
  }
  filters = [
    {
      label: '关键字搜索：',
      type: 'input',
      props: {
        placeholder: '订单编号/用户名/手机号',
      },
      key: 'KeyWord',
    },
    {
      label: '申请时间：',
      type: 'date',
      key: 'CreationTime',
      defaultValue: '',
    },
  ]
  columns: any[] = [
    {
      type: 'selection',
      width: 60,
      align: 'center',
    },
    {
      title: '订单编号',
      key: 'orderNo',
      align: 'center',
    },
    {
      title: '商品信息',
      slot: 'productItem',
      align: 'center',
      width: 350,
    },
    {
      title: '预计退款金额',
      slot: 'expectedRefundAmount',
      align: 'center',
    },
    {
      title: '实际退款金额',
      slot: 'refundAmount',
      align: 'center',
    },
    {
      title: '申请类型',
      slot: 'refundType',
      align: 'center',
    },
    {
      title: '申请人',
      slot: 'name',
      align: 'center',
    },
    {
      title: '申请时间',
      slot: 'creationTime',
      align: 'center',
    },
    {
      title: '申请状态',
      slot: 'applyStatus',
      align: 'center',
    },
    {
      title: '操作',
      slot: 'action',
      width: 150,
      align: 'center',
    },
  ]
  loading: boolean = false
  tabList = ['全部申请', '待处理', '处理中', '已完成', '已拒绝']
  activeTab = 0
  tableData: any[] = []
  copyTableDate: any[] = []
  page = {
    totalCount: 0,
    currentPage: 1,
    maxResultCount: 10,
  }

  mounted() {
    this.submitFn()
  }

  submitFn() {
    let form: any = this.$refs.lineForm
    form.submit()
  }

  onSubmit(form, valid) {
    if (valid) {
      this.getrefundList(form)
    }
  }

  /**
   * 获取退款列表
   */
  getrefundList(form?) {
    let { page, activeTab } = this
    this.loading = true
    let keyWord = form ? form['KeyWord'] : null
    let CreationTime = form ? this.dateString(form['CreationTime']) : null
    let status = activeTab == 0 ? null : activeTab - 1
    OrderRefundApi.getrefundList(
      page.maxResultCount,
      page.currentPage,
      keyWord,
      CreationTime,
      status,
      'CreationTime desc'
    )
      .then((res) => {
        this.loading = false
        this.page.totalCount = res.data.totalCount
        this.tableData = res.data.items
        this.copyTableDate = this._integratedData(res.data.items)
      })
      .catch((err) => {
        this.loading = false
      })
  }

  changePage(e) {
    this.page.currentPage = e
    this.submitFn()
  }
  pageSizeChange(e, t) {
    this.page.maxResultCount = e
    this.page.currentPage = 1
    this.submitFn()
  }
  goDetailFn(id) {
    this.$router.push({
      name: 'refundDetail',
      query: {
        id: id,
      },
    })
  }

  statusString(status) {
    let text = status
    switch (status) {
      case 0:
        text = '待处理'
        break
      case 1:
        text = '处理中'
        break
      case 2:
        text = '已完成'
        break
      case 3:
        text = '已拒绝'
        break
      case 4:
        text = '已取消'
        break
      default:
        text = status
        break
    }
    return text
  }
  showModal(serviceNumber) {
    OrderRefundApi.getErpReturnOrder(serviceNumber).then((res) => {
      console.log(res)
      if (res.status === 204) {
        this.$Message.warning('查询不到退货单记录')
        this.updateGuanYiTradeNoModal = false
      } else {
        this.formItem.id = res.data.id
        this.formItem.externalCode = res.data.externalCode
        this.updateGuanYiTradeNoModal = true
      }
    })
  }
  updateGuanYiTradeNo(serviceNumber) {
    OrderRefundApi.updateErpReturnOrder(this.formItem.id, this.formItem.externalCode).then((res) => {
      this.$Message.success('保存成功')
      this.updateGuanYiTradeNoModal = false
    })
  }
  // 表格合并
  handleSpan({ row, column, rowIndex, columnIndex }) {
    if (columnIndex != 2) {
      return {
        rowspan: row.mergeCol === 0 ? 0 : row.mergeCol,
        colspan: row.mergeCol === 0 ? 0 : 1,
      }
    }
  }
  _integratedData(data) {
    // 接收数组
    var lastArr = []
    data.forEach((item, firstIndex) => {
      // 遍历数组
      item.refundOrderItems.forEach((innerItem, attrIndex) => {
        // 遍历数组下面的需要合并数组
        lastArr.push(
          // 遍历完成后添加到新数组中去
          Object.assign({}, item, {
            mergeCol: attrIndex === 0 ? item.refundOrderItems.length : 0,
            refundInfo: innerItem, // row.productInfo.xxx
          })
        )
      })
    })
    return lastArr
  }
}
